import { Component, ChangeDetectorRef } from "@angular/core";
import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalConfig,
} from "@ng-bootstrap/ng-bootstrap";
import { HttpService } from "../../service/HTTPService/HttpService";
import { BindingURLService } from "../../service/Bindingurlservice/binding-url.service";
import Swal from "sweetalert2";
import { Globals } from "../../globals";
import { ApiService } from "../../service/apiUrls/apiUrl.service";

@Component({
  selector: "app-actions-cell",
  template: `<select
      style="height:34px;font-size: 13px;width: 96px;margin-top:2px;margin-left:-15px"
      class="form-control"
      [(ngModel)]="selectedoption"
      (change)="optionChanged($event.target.value, configureModal)"
      name="sel2"
    >
      <option class="newOption" value="Action" disabled selected>Action</option>
      <option class="newOption" value="Poll">Poll</option>
    </select>
    <!--<select
      style="height:34px;font-size: 13px;width: 96px;margin-top:2px;margin-left:-15px"
      class="form-control"
      [(ngModel)]="selectedoption"
      (change)="optionChanged($event.target.value, configureModal)"
      name="sel2"
    >
      <option class="newOption" value="Action" disabled selected>Action</option>
      <option class="newOption" value="Configure">Configured Alarms</option>
      <option class="newOption" value="Poll">Poll</option>
    </select> -->
    <ng-template #configureModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Configured Alarms</h4>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <ngb-tabset>
          <ngb-tab title="Open Alarms">
            <ng-template ngbTabContent>
              <div class="style-3" id="TabScroll">
                <div *ngFor="let alarm of openAlarm">
                  <div
                    [ngStyle]="{
                      'border-left': '3px solid' + alarm.color,
                      height: '22px',
                      padding: '5px 0px 30px 10px'
                    }"
                  >
                    <span>{{ alarm.name }} on {{ alarm.time }}</span>
                  </div>
                  <hr id="tabScrollhr" />
                </div>
              </div>
            </ng-template>
          </ngb-tab>
          <ngb-tab title="Critical">
            <ng-template ngbTabContent>
              <div class="style-3" id="criticalTabScroll">
                <div *ngFor="let alarm of criticalAlarm">
                  <div
                    [ngStyle]="{
                      'border-left': '3px solid' + alarm.color,
                      height: '22px',
                      padding: '5px 0px 30px 10px'
                    }"
                  >
                    <span>{{ alarm.name }}</span>
                  </div>
                  <hr id="tabScrollhr" />
                </div>
              </div>
            </ng-template>
          </ngb-tab>
          <ngb-tab title="Major">
            <ng-template ngbTabContent>
              <div class="style-3" id="majorTabScroll">
                <div *ngFor="let alarm of majorAlarm">
                  <div
                    [ngStyle]="{
                      'border-left': '3px solid' + alarm.color,
                      height: '22px',
                      padding: '5px 0px 30px 10px'
                    }"
                  >
                    <span>{{ alarm.name }}</span>
                  </div>
                  <hr id="tabScrollhr" />
                </div>
              </div>
            </ng-template>
          </ngb-tab>
          <ngb-tab title="Minor">
            <ng-template ngbTabContent>
              <div class="style-3" id="minorTabScroll">
                <div *ngFor="let alarm of minorAlarm">
                  <div
                    [ngStyle]="{
                      'border-left': '3px solid' + alarm.color,
                      height: '22px',
                      padding: '5px 0px 30px 10px'
                    }"
                  >
                    <span>{{ alarm.name }}</span>
                  </div>
                  <hr id="tabScrollhr" />
                </div>
              </div>
            </ng-template>
          </ngb-tab>
        </ngb-tabset>
      </div>
    </ng-template> `,
  styles: [
    `
      .style-3::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: #f5f5f5;
      }
      .style-3::-webkit-scrollbar {
        width: 6px;
        background-color: #f5f5f5;
      }

      .style-3::-webkit-scrollbar-thumb {
        background-color: #999999;
      }
    `,
  ],
})
export class SiteListActionRendererComponent
  implements ICellRendererAngularComp
{
  selectedoption = "Action";
  closeResult: string;
  public params: any;
  public sid = "";
  openAlarm: any[] = [];
  criticalAlarm: any[] = [];
  majorAlarm: any[] = [];
  minorAlarm: any[] = [];
  alerts: any[] = [];
  siteCommandDetails;
  arr_InternalAlertMsg: any[] = [];

  constructor(
    private modalService: NgbModal,
    private globals: Globals,
    private cdr: ChangeDetectorRef,
    config: NgbModalConfig,
    private http: HttpService,
    private urlAuthentication: BindingURLService,
    private apiUrl: ApiService
  ) {
    config.backdrop = "static";

  }
  agInit(params: any): void {
    this.params = params;
    this.sid = this.params.data.SiteID;
  }
  refresh(): boolean {
    return false;
  }
  optionChanged(option, configureModal) {
    this.selectedoption = "";
    this.cdr.detectChanges();

    if (option == "Configure" && configureModal != undefined) {
      this.selectedoption = "Action";
      this.openConfigureModal(configureModal);

      const reqAlarms = { fmID: 623, siteID: this.sid.toString() };
      this.http
        .genericApi(this.urlAuthentication.genericApiUrl, reqAlarms)
        .subscribe(
          (res) => {
            const data = res.response[0].Data;
            this.openAlarm = [];
            this.criticalAlarm = [];
            this.majorAlarm = [];
            this.minorAlarm = [];
            for (let i = 0; i < data.length; i++) {
              if (data[i].Status == 1 && data[i].Criticality == 3) {
                this.openAlarm.push({
                  name: data[i].Alarm,
                  time: data[i].OpenTime,
                  color: "#E57373",
                });
                this.criticalAlarm.push({
                  name: data[i].Alarm,
                  color: "#E57373",
                  status: data[i].Status,
                  priority: 3,
                });
              } else if (data[i].Status == 1 && data[i].Criticality == 2) {
                this.openAlarm.push({
                  name: data[i].Alarm,
                  time: data[i].OpenTime,
                  color: "#FFB74D",
                });
                this.majorAlarm.push({
                  name: data[i].Alarm,
                  color: "#FFB74D",
                  status: data[i].Status,
                  priority: 2,
                });
              } else if (data[i].Status == 1 && data[i].Criticality == 1) {
                this.openAlarm.push({
                  name: data[i].Alarm,
                  time: data[i].OpenTime,
                  color: "#FFF167",
                });
                this.minorAlarm.push({
                  name: data[i].Alarm,
                  color: "#FFF167",
                  status: data[i].Status,
                  priority: 1,
                });
              }
              if (data[i].Criticality == 3 && data[i].Status == 0) {
                this.criticalAlarm.push({
                  name: data[i].Alarm,
                  color: "#09AF00",
                  status: 2,
                  priority: 3,
                });
              } else if (data[i].Criticality == 3 && data[i].Status == 8) {
                this.criticalAlarm.push({
                  name: data[i].Alarm,
                  color: "#999999",
                  status: data[i].Status,
                  priority: 3,
                });
              }
              if (data[i].Criticality == 2 && data[i].Status == 0) {
                this.majorAlarm.push({
                  name: data[i].Alarm,
                  color: "#09AF00",
                  status: 2,
                  priority: 2,
                });
              } else if (data[i].Criticality == 2 && data[i].Status == 8) {
                this.majorAlarm.push({
                  name: data[i].Alarm,
                  color: "#999999",
                  status: data[i].Status,
                  priority: 2,
                });
              }
              if (data[i].Criticality == 1 && data[i].Status == 0) {
                this.minorAlarm.push({
                  name: data[i].Alarm,
                  color: "#09AF00",
                  status: 2,
                  priority: 1,
                });
              } else if (data[i].Criticality == 1 && data[i].Status == 8) {
                this.minorAlarm.push({
                  name: data[i].Alarm,
                  color: "#999999",
                  status: data[i].Status,
                  priority: 1,
                });
              }
            }
            this.openAlarm.sort(function (a, b) {
              var dateA: any = new Date(a.time),
                dateB: any = new Date(b.time);
              return dateA - dateB;
            });
            this.criticalAlarm.sort(function (a, b) {
              var priorityA: any = a.status,
                priorityB: any = b.status;
              return priorityA - priorityB;
            });
            this.majorAlarm.sort(function (a, b) {
              var priorityA: any = a.status,
                priorityB: any = b.status;
              return priorityA - priorityB;
            });
            this.minorAlarm.sort(function (a, b) {
              var priorityA: any = a.status,
                priorityB: any = b.status;
              return priorityA - priorityB;
            });

            if (this.openAlarm.length == 0) {
              this.openAlarm.push({
                name: "No open alarms",
              });
            }
          },
          (error) => {
            console.error(error);

           
          }
        );
    }
    if (option == "Poll") {
      this.selectedoption = "Action";
      const reqParams = { fmID: 504, siteID: this.sid.toString() };
      this.http
        .genericApi(this.urlAuthentication.genericApiUrl, reqParams)
        .subscribe(
          (res) => {
            const data = res.response[0].Data[0];
            this.siteCommandDetails = data;
            this.SiteListingPollClicked();
          },
          (error) => {
            console.error(error);
          }
        );
    }
  }

  SiteListingPollClicked() {
    const imgJson = {
      title: "",
      SiteID: this.sid,
      DeviceSerialNumber: this.siteCommandDetails.deviceSerialNumber.toString(),
      ControllerID: 1000, //Specifically for poll is 1000
      CommandType: "Command",
      GprsID: this.siteCommandDetails.GprsID.toString(),
      ModemID: this.siteCommandDetails.ModemID.toString(),
      PortNumber: this.siteCommandDetails.portNumber,
      ReplyMode: 0,
      DelayTime: 0,
      IPAddress: this.siteCommandDetails.ipaddress.toString(),
    };
    this.http
      .post(
        this.urlAuthentication.crudApiUrl + this.apiUrl.commandsUrl,
        imgJson
      )
      .subscribe(
        (res) => {
          let resp = res;
          Swal.fire({
            text: res.message,
            icon: "success",
          });
        },
        (error) => {
          console.error(error);
          Swal.fire({
            text: error.message,
            icon: "warning",
          });
        }
      );
  }
  setMessage(msg, type) {
    this.globals.message = "";
    this.globals.messageType = "";
    this.globals.message = msg;
    this.globals.messageType = type;
    this.params.context.componentParent.ngOnInit();
  }
  setInternalMessage(message, messageType) {
    if (message != "" && messageType != "") {
      this.arr_InternalAlertMsg = [];
      this.arr_InternalAlertMsg.push({
        type: messageType,
        message: message,
      });
    } else {
      this.arr_InternalAlertMsg = [];
    }
  }
  /**
   * To open the Export Modal
   * @param content
   */

  openConfigureModal(content) {
    this.modalService
      .open(content, { ariaLabelledBy: "modal-basic-title" })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}
